module.exports = __webpack_public_path__ + "static/teck_4-ec43ed4c115adf776115690792cfb58c.jpg";